import template from './CustomerEditModule.html';
import store from '../../store/store';
import CustomerDeliveryFormComponent from '../../components/CustomerDeliveryForm/CustomerDeliveryFormComponent';
import CustomerInvoiceFormComponent from '../../components/CustomerInvoiceForm/CustomerInvoiceFormComponent';

export default {
  template,

  components: {
    CustomerDeliveryFormComponent,
    CustomerInvoiceFormComponent,
  },

  props: {
    customerUserData: {
      type: Object,
    },
  },

  data() {
    return {
      sharedState: store,
    };
  },

  created() {
    // The form components read from 'store'; add authUser to it:
    store.addAuthUser(this.customerUserData);
  },
};
